import React from 'react'
import { withIcon } from '../../withIcon'

function StackedCardsIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="6.60004" y="5" width="14.4" height="10.5" rx="1" fill={color} />
      <rect x="5.70001" y="5.875" width="14.4" height="10.5" rx="1" fill="white" />
      <rect x="4.79999" y="6.75" width="14.4" height="10.5" rx="1" fill={color} />
      <rect x="3.89996" y="7.625" width="14.4" height="10.5" rx="1" fill="white" />
      <rect x="3.5" y="9" width="13.4" height="9.5" rx="0.5" fill="white" stroke={color} />
    </svg>
  )
}

export default withIcon(StackedCardsIcon)
